import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { QRCodeResponse } from '@interfaces/megaapi.interface';
import { WhatsappInstanceInfoI } from '@interfaces/whatsapp-instance-info.interface';
import { ChannelStatusResponseI } from '@interfaces/channel-status.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WhatsappOmniService {
  private qrcodeSlug: string = 'whatsapp-omni/qrbase64/';
  private isOnWhatsappSlug: string = 'whatsapp-omni/onwhatsapp/';
  private setStatusSlug: string = 'whatsapp-omni/setstatus/';
  private instanceInfo: string = 'whatsapp-omni/instance-info/';
  private channelStatusSlug: string = 'whatsapp-omni/channel-status/';

  constructor(private http: HttpClient) {}

  public isOnWhatsapp(instance: string, jid: string): Observable<any> {
    return this.http.get(`${environment.OMNISMART_API_WHATSAPP_OMNI}${this.isOnWhatsappSlug}${instance}/${jid}`);
  }

  public setChatActionStatus({
    jid,
    instance,
    option,
  }: {
    jid: string;
    instance?: string;
    option: string;
  }): Observable<any> {
    return this.http.post(`${environment.OMNISMART_API_WHATSAPP_OMNI}${this.setStatusSlug}${instance}`, {
      id: jid,
      status: option,
    });
  }

  public getQrCode(instance: string): Observable<QRCodeResponse> {
    return this.http.get<QRCodeResponse>(`${environment.OMNISMART_API_WHATSAPP_OMNI}${this.qrcodeSlug}${instance}`);
  }

  public getInstanceInfo(instance: string) {
    return this.http.get<WhatsappInstanceInfoI | null>(
      `${environment.OMNISMART_API_WHATSAPP_OMNI}${this.instanceInfo}${instance}`
    );
  }

  // Status completo do canal (conexão, restrição, QR se houver) numa única request.
  public getChannelStatus(instance: string): Observable<ChannelStatusResponseI> {
    return this.http.get<ChannelStatusResponseI>(
      `${environment.OMNISMART_API_WHATSAPP_OMNI}${this.channelStatusSlug}${instance}`
    );
  }
}
